/* assets/d-lazy-video.js */

/*
 * Video decorativo em duas etapas, para nao pesar no carregamento e ainda assim
 * ja estar tocando quando o visitante chega na section.
 *
 *   1. PREPARAR (300px antes de entrar na tela)
 *      Anexa as sources com preload="metadata" e chama load(). Busca o playlist
 *      e o suficiente para o primeiro quadro, nao o arquivo todo.
 *   2. TOCAR (10% visivel)
 *      Da play. Como o player ja esta inicializado, comeca quase instantaneo.
 *
 * Historico das medicoes, para ninguem desfazer sem saber o custo:
 *   - `video_tag` com autoplay baixava os 13 videos da home no load: 87 MB.
 *   - Carregar tudo com rootMargin de 200px e tocar junto: 30 MB, mas os videos
 *     abaixo da dobra roubavam banda do hero e o LCP subiu 2s.
 *   - Esperar 500ms visivel antes de tocar: 25 MB, porem o video so comecava
 *     depois de o visitante parar de rolar. Ruim de UX.
 *   - Este arquivo: prepara antes, toca ao aparecer. Mantem o peso baixo e o
 *     autoplay percebido como imediato.
 */
(function () {
  var SELECTOR = 'video[data-lazy-video]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Distancia de antecipacao do preparo. Suficiente para o player estar pronto
     quando o visitante chega, sem puxar midia de secoes distantes. */
  var PREP_MARGIN = '300px 0px';
  /* Rolagem rapida nao deve disparar uma fila de players. */
  var PLAY_DELAY = 120;

  var prepObserver = null;
  var playObserver = null;
  var timers = new WeakMap();

  function prepare(video) {
    if (!video || video.dataset.prepared === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;
    video.muted = true;
    video.setAttribute('preload', 'metadata');
    /* Ordem do Shopify: HLS primeiro, mp4 como fallback. */
    Array.prototype.forEach.call(sources, function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });
    video.dataset.prepared = 'true';
    video.load();
  }

  function play(video) {
    prepare(video);
    video.setAttribute('preload', 'auto');
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  /* Mantido para quem chama de fora, como o botao de som do carrossel. */
  function load(video) {
    prepare(video);
  }

  function cancelPending(video) {
    var timer = timers.get(video);
    if (timer) {
      clearTimeout(timer);
      timers.delete(video);
    }
  }

  function onPrep(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        prepare(entry.target);
        if (prepObserver) prepObserver.unobserve(entry.target);
      }
    });
  }

  function onPlay(entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting) {
        if (timers.has(video) || !video.paused) return;
        timers.set(
          video,
          setTimeout(function () {
            timers.delete(video);
            play(video);
          }, PLAY_DELAY)
        );
      } else {
        cancelPending(video);
        if (!video.paused) video.pause();
      }
    });
  }

  function init(root) {
    /* Quem pediu menos movimento nao vai ver o video tocando, entao nao ha por
       que preparar o arquivo nem agendar nada: o poster resolve. */
    if (reduceMotion) return;

    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll(SELECTOR);
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, function (video) {
        prepare(video);
        play(video);
      });
      return;
    }

    if (!prepObserver) {
      prepObserver = new IntersectionObserver(onPrep, { rootMargin: PREP_MARGIN, threshold: 0 });
      playObserver = new IntersectionObserver(onPlay, { rootMargin: '0px', threshold: 0.1 });
    }

    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset.observed === 'true') return;
      video.dataset.observed = 'true';
      prepObserver.observe(video);
      playObserver.observe(video);
    });
  }

  window.DLazyVideo = { load: load, play: play, init: init };

  /* Só depois do load da pagina: nada compete com o video do hero, que e o
     elemento de LCP da home. */
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', function () { init(); }, { once: true });
  }

  /* Editor de temas: sections recarregadas precisam ser reobservadas. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
